import { createTheme } from '@mui/material';

const getTheme = (mode) => createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    h1: {
      fontFamily: '"Open Sans", sans-serif',
    },
    h2: {
      fontFamily: '"Open Sans", sans-serif',
    },
    h3: {
      fontFamily: '"Open Sans", sans-serif',
    },
    h4: {
      fontFamily: '"Open Sans", sans-serif',
    },
    h5: {
      fontFamily: '"Open Sans", sans-serif',
    },
    h6: {
      fontFamily: '"Open Sans", sans-serif',
    },
    subtitle1: {
      fontFamily: '"Open Sans", sans-serif',
    },
    subtitle2: {
      fontFamily: '"Open Sans", sans-serif',
    },
    body1: {
      fontFamily: '"Open Sans", sans-serif',
    },
    body2: {
      fontFamily: '"Open Sans", sans-serif',
    },
    button: {
      fontFamily: '"Open Sans", sans-serif',
    },
    caption: {
      fontFamily: '"Open Sans", sans-serif',
    },
    overline: {
      fontFamily: '"Open Sans", sans-serif',
    },
  },
  palette: {
    mode, 
    primary: {
      main: '#34847d',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#ff1744',
    },
    background: {
      default: mode === 'light' ? '#fff' : '#121212', 
    },
  },
});

export default getTheme;
